import request from '../utils/request';

// 获取左侧界面数据请求
// export const getLeftPageData = async () => {
//   return request('/api/leftPageData').then(response => {
//     return response.data;
//   });
// };
export const getLeftPageData = async () => {
    const cacheKey = 'leftPageData'; // 缓存键名
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime(); // 今天0点的时间戳

    // 1. 尝试从localStorage读取缓存
    const cachedData = localStorage.getItem(cacheKey);
    if (cachedData) {
      const { data, saveTime } = JSON.parse(cachedData);
      // 判断缓存是否在今天内（未超过当天）
      if (saveTime >= today) {
        console.log('使用今日缓存数据');
        return data; // 返回缓存数据
      } else {
        console.log('缓存已过期（非今日数据），将重新请求');
        localStorage.removeItem(cacheKey); // 删除过期缓存
      }
    }
    const postData = {
      member_id: 8888,
      platform_member_id: 8888,
      time_type: 'day',
      child_id: -1,
      type: 0,
    };
    // return request('https://share.lkcsz.com/treasure/order/yearningsList',{
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json', // 指定 JSON 格式
    //         //'Authorization': 'Bearer your_token_here' // 可选：如果需要认证
    //       },
    //       body: JSON.stringify(postData) // 将对象转换为 JSON 字符串
    // }).then(response => {
    //       if(response.code == 200) {
    //         // 3. 保存数据到localStorage，记录当前时间戳
    //         localStorage.setItem(cacheKey, JSON.stringify({
    //           data: response.data,
    //           saveTime: Date.now() // 记录保存时的时间戳
    //         }));
    //         console.log('请求成功并缓存数据');
    //         return response.data;
    //       }else{
    //         console.error('请求失败:', response.msg);
    //       }
    // });
    try {
      const response = await fetch('https://share.lkcsz.com/treasure/order/yearningsList', {//切换下方跨域代理
      //const response = await fetch('/treasure/order/yearningsList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      });
      if (!response.ok) {
        throw new Error(`请求失败: ${response.status}`);
      }

      const data = await response.json();
      const nowtime = Date.now();
      // 3. 保存数据到localStorage，记录当前时间戳
      localStorage.setItem(cacheKey, JSON.stringify({
        data: data,
        saveTime: nowtime, // 记录保存时的时间戳
        updateTime: nowtime,
      }));

      console.log('请求成功并缓存数据');
      return data;

    } catch (err) {
      console.error('请求失败:', err);
      // 若有缓存（即使过期），可降级返回（可选）
      if (cachedData) {
        const { data } = JSON.parse(cachedData);
        console.log('请求失败，返回过期缓存');
        return data;
      }
      throw err; // 无缓存时抛出错误
    }
};


// // 封装带缓存的请求函数
// export const getLeftPageData = async () => {
//   const cacheKey = 'leftPageData'; // 缓存键名
//   const now = new Date();
//   const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime(); // 今天0点的时间戳
//
//   // 1. 尝试从localStorage读取缓存
//   const cachedData = localStorage.getItem(cacheKey);
//   if (cachedData) {
//     const { data, saveTime } = JSON.parse(cachedData);
//     // 判断缓存是否在今天内（未超过当天）
//     if (saveTime >= today) {
//       console.log('使用今日缓存数据');
//       return data; // 返回缓存数据
//     } else {
//       console.log('缓存已过期（非今日数据），将重新请求');
//       localStorage.removeItem(cacheKey); // 删除过期缓存
//     }
//   }
//
//   // 2. 缓存不存在或过期，发起请求
//   const postData = {
//     member_id: 8888,
//     platform_member_id: 8888,
//     time_type: 'day',
//     child_id: -1,
//   };
//
//   try {
//     const response = await fetch('https://share.lkcsz.com/treasure/order/yearningsList', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(postData),
//     });
//
//     if (!response.ok) {
//       throw new Error(`请求失败: ${response.status}`);
//     }
//
//     const data = await response.json();
//
//     // 3. 保存数据到localStorage，记录当前时间戳
//     localStorage.setItem(cacheKey, JSON.stringify({
//       data: data,
//       saveTime: Date.now() // 记录保存时的时间戳
//     }));
//
//     console.log('请求成功并缓存数据');
//     return data;
//
//   } catch (err) {
//     console.error('请求失败:', err);
//     // 若有缓存（即使过期），可降级返回（可选）
//     if (cachedData) {
//       const { data } = JSON.parse(cachedData);
//       console.log('请求失败，返回过期缓存');
//       return data;
//     }
//     throw err; // 无缓存时抛出错误
//   }
// };



// 获取中间界面数据请求
export const getCenterPageData = async () => {
  return [];
  return request('/api/centerPageData').then(response => {
    return response.data;
  });
};

// 获取右侧界面数据请求
export const getRightPageData = async () => {
  return [];
  return request('/api/rightPageData').then(response => {
    return response.data;
  });
};
